import PropTypes from 'prop-types';
import { Component } from 'react';

// @ts-expect-error needs types
import ApiExplorer from './ApiExplorer';
import { mutateTrackerInstance } from '../../../tracking/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class DeveloperDoc extends Component {
  render() {
    const {
      specWithExtensions,
      oasDocs,
      headerId,
      usageTracker
    } = this.props;
    const mutatedTracker = mutateTrackerInstance(usageTracker);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(ApiExplorer, {
        oasDocs: oasDocs,
        oasFiles: {
          'api-setting': specWithExtensions
        },
        flags: {
          correctnewlines: false
        },
        headerId: headerId,
        usageTracker: mutatedTracker
      })
    });
  }
}
DeveloperDoc.propTypes = {
  oasDocs: PropTypes.array,
  specWithExtensions: PropTypes.object,
  usageTracker: PropTypes.object.isRequired
};
export default DeveloperDoc;